import { FC } from 'react';
import { useTranslation } from '../translations';

export const Currency: FC<{ readonly value: number }> = ({ value }) => {
  const { currency } = useTranslation();

  return currency(value);
};
